import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { homePathFor } from "@/lib/roles";

export const ProtectedRoute = ({ children, allow }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="grid min-h-screen place-items-center bg-oath-bg" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-oath-muted" />
      </div>
    );
  }
  if (!user) return <Navigate to="/signin" replace state={{ from: location.pathname }} />;
  if (allow && !allow(user)) return <Navigate to={homePathFor(user)} replace />;
  return children;
};

export default ProtectedRoute;
